'use client';
import { ReactNode } from 'react';
import LoaderOverlay from 'components/loader-overlay';
import { useLoaderOverlay } from 'app/[lang]/[esite]/contexts/loader-overlay-context';

interface LoaderWrapperProps {
  children: ReactNode;
}

const LoaderWrapper = ({ children }: LoaderWrapperProps) => {
  const { isLoading } = useLoaderOverlay();
  return (
    <div className="position-relative">
      {isLoading && <LoaderOverlay />}
      {children}
    </div>
  );
};

export default LoaderWrapper;
